import { useState, useEffect } from "react";
import "../css/Login.css";
console.log("LoginScreen rendered");

function LoginScreen({ onLogin }) {
  const loginStr = "viewer";
  const passStr = "*******";

  const [loginText, setLoginText] = useState("");
  const [passText, setPassText] = useState("");
  const [accessText, setAccessText] = useState("");

  useEffect(() => {
    let loginIndex = 0;
    let passIndex = 0;

    const loginInterval = setInterval(() => {
      if (loginIndex < loginStr.length) {
        setLoginText(loginStr.slice(0, loginIndex + 1));
        loginIndex++;
      } else {
        clearInterval(loginInterval);

        setTimeout(() => {
          const passInterval = setInterval(() => {
            if (passIndex < passStr.length) {
              setPassText(passStr.slice(0, passIndex + 1));
              passIndex++;
            } else {
              clearInterval(passInterval);

              setTimeout(() => {
                setAccessText("Access granted...");

                setTimeout(() => {
                  onLogin();
                }, 1500);
              }, 500);
            }
          }, 100);
        }, 700);
      }
    }, 100);

    return () => {
      clearInterval(loginInterval);
    };
  }, [onLogin]);
  return (
    <div className="login-screen">
      <div className="login-box">
        <p className="login-line">
          <span className="prompt">user:</span>
          <span className="fake-input">{loginText}</span>
        </p>

        <p className="login-line">
          <span className="prompt">password:</span>
          <span className="fake-input">{passText}</span>
        </p>

        <p className="login-msg">{accessText}</p>
      </div>
    </div>
  );
}
export default LoginScreen;
